<footer class="app-footer">
  <div class="container app-footer__con">
    <div class="app-footer__con__wr">
      <!-- <p class="app-footer__con__wr__p">
        PRO.CONNECT to miejsce stworzone dla fryzjerów, pragnących rozwijać się nowocześnie, świadomie i z pasją.
        Kochamy być w ciągłym ruchu, zdobywać nową wiedzę i inspirować się trendami, zawsze z największą uwagą i
        szacunkiem dla sztuki fryzjerskiej.
      </p> -->
      <img
        ngSrc="assets/images/pro-connect-logo.svg"
        [priority]="false"
        alt="logo"
        class="app-footer__con__logo"
        height="596"
        width="1120"
      />
      <div class="d-flex flex-lg-row flex-column justify-content-start justify-content-lg-center">
        <ul class="app-footer__con__wr__ul list-unstyled">
          <li>
            <a [routerLink]="['/']" (click)="pushLayer('homePage', 'footer')">Strona główna</a>
          </li>
          <li>
            <a [routerLink]="['/' + WwwRouteSlug.CONTACT]" (click)="pushLayer('contact', 'footer')">Kontakt</a>
          </li>
          <li>
            <a [routerLink]="['/', WwwRouteSlug.COOKIES_POLICY]" (click)="pushLayer('cookies-policy', 'footer')"
              >Polityka cookies</a
            >
          </li>
          <li>
            <a href="/assets/files/Regulamin PRO.CONNECT_2025.pdf" target="_blank">Regulamin programu</a>
          </li>
          <li>
            <a [routerLink]="['/', WwwRouteSlug.PRIVACY_POLICY]">Polityka prywatności</a>
          </li>
          <li>
            <a class="optanon-toggle-display" href="#">Ustawienia plików cookie</a>
          </li>
        </ul>

        <div class="app-footer__con__wr__log">
          <a href="https://pl.lorealpartnershop.com/pl" target="_blank">
            <img
              ngSrc="assets/images/footer-logo-2.webp"
              [priority]="false"
              alt="logo"
              height="111"
              width="380"
              class="app-footer__con__wr__log__fir"
          /></a>
          <a href="https://www.lorealaccess.com/" target="_blank">
            <img
              ngSrc="assets/images/footer-logo-3.webp"
              [priority]="false"
              alt="logo"
              height="146"
              width="390"
              class="app-footer__con__wr__log__sec"
          /></a>
        </div>
      </div>
    </div>
  </div>
</footer>
